/**
 *  SGPowerMailShowField
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGPowerMailShowField = function(options) {

        var settings = $.extend( {}, $.fn.SGPowerMailShowField.defaults, options );

        return this.each(function() {
            var $this = $(this);
            $(settings.toShow).hide();
            $this.on('change', function(){
                if($(this).val() == settings.reactiveFieldValue){
                    $(settings.toShow).show();
                } else {
                    $(settings.toShow).hide();
                }
            });
        });
    }

    $.fn.SGPowerMailShowField.defaults = {
        'reactiveFieldValue' : '',
        'toShow': ''
    };
})(jQuery);

/**
 * SGFilterChilds
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGFilterChilds = function(options) {

        var settings = $.extend( {}, $.fn.SGFilterChilds.defaults, options );

        return this.each(function() {
            var $this = $(this);
            var filter = options.filter;
            var showItemIfEmpty = options.showItemIfEmpty;
            $this.attr('data-filter', filter);
            if(filter){
                var haveItemDisplay = false;
                $(this).children().each(function(){
                    if($(this).hasClass(filter)){
                        $(this).show();
                        haveItemDisplay = true;
                    } else {
                        $(this).hide();
                    }
                });

                if(showItemIfEmpty) {
                    $(this).find(showItemIfEmpty).hide();
                    if (!haveItemDisplay) {
                        $(this).find(showItemIfEmpty).show();
                    } else {
                        $(this).find(showItemIfEmpty).hide();
                    }
                }

            } else {
                $(this).children().show();
            }

        });
    }



    $.fn.SGFilterChilds.defaults = {};

})(jQuery);

/**
 * SGImportFundsFilter
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGImportFundsFilter = function(options) {

        var settings = $.extend( {}, $.fn.SGImportFundsFilter.defaults, options );

        return this.each(function() {
            $.cookie.json = true;
            var dd = $.cookie('disclaimerDatas');
            if(dd != undefined && dd != 'null'){
                var filter = dd.lang.toUpperCase();
                console.debug('SGImportFundsFilter', dd , filter);
                $(this).SGFilterChilds({filter: filter});

            }
        });
    }



    $.fn.SGImportFundsFilter.defaults = {};

})(jQuery);

/**
 * SGMovingLine
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGMovingLine = function(options) {

        var settings = $.extend( {}, $.fn.SGMovingLine.defaults, options );

        return this.each(function() {


            var curent = $(this);

            // on ne le fait qu'un seule fois
            if(curent.hasClass('mlTitle')){
                return;
            }

            // changement dans le markup pour avoir une movin line relatif à la largeur du texte, et non à la largeur du div contenant le texte
            curent.wrapInner('<span class="mlTitle__content"></span>');

            var cWidth = curent.find('.mlTitle__content').width();
            var lineHeight = Math.floor(parseInt(curent.css("fontSize")) / 4.5); // on calcul la taille de la line automatiquement, taille de la police % 4.5
            var lineWidthMin = cWidth * 0.3; // definie la largeur minimum
            var lineWidthMax = cWidth * 0.75; // definie la largeur maximum
            var lineWidth =
                Math.random() * (lineWidthMax - lineWidthMin) + lineWidthMin;

            var lineOffsetXMin = -cWidth * 0.3; // décalage minimum équivant a 10% du titre
            var lineOffsetXMax = cWidth - lineWidth; // décalage maximum équivaut a la taille du titre - la taille de la line, comme ca elle ne sort jamais du container
            var lineOffsetX =
                (Math.random() * (lineOffsetXMax - lineOffsetXMin) + lineOffsetXMin) *
                0.2; // Le 0.5 correspond a un ratio arbitraire qui est moduable

            curent.addClass("mlTitle");



            // console.debug(curent);
            // gestion de la couleurs, si le texte est rouge SG on passe la moving line en noir, sinon on passe en rouge
            // vrai couleur SG 230,0,40 (e60028)
            // couleur E1 233,4,30 (e9041e)
            let barColor = GBIS.movingLineColor;

            const parentColored = curent.parents('.colored');

            // si texte rouge E1 ==> moving line en noir
            if(curent.css("color") === 'rgb(233, 4, 30)') {
                barColor = '#000000'
            }

            // si fond est rouge et variante :
            //      si texte blanc => barre noire
            //      sinon ==> barre blanche
            // attention pour le slider en mode "image", mcette règle ne s'applique pas
            if(!parentColored.hasClass('tx-bisgslider__slide--image') && (parentColored.hasClass('colorBgE1') || parentColored.hasClass('colorBgE2') || parentColored.hasClass('colorBgE3') || parentColored.hasClass('colorBgE4') || parentColored.hasClass('colorBgE5'))) {
                if(curent.css("color") === 'rgb(255, 255, 255)') {
                    barColor = '#000000';
                } else {
                    barColor = '#ffffff';
                }
            }

            var movingBar = $("<span />")
                .addClass("mlTitle__bar")
                .css({
                    bottom: -(lineHeight * 0.22) + 'rem', // le décallage est relatif a la taille de la moving line
                    height: (lineHeight / 10) + 'rem',
                    backgroundColor: barColor
                })
                .appendTo($(this).find('.mlTitle__content'));

            setTimeout(function() {
                movingBar.css({
                    transform: "translateX(" + (lineOffsetX / 10) + "rem)",
                    width: lineWidth
                });
            }, 200);

        });
    };



    $.fn.SGMovingLine.defaults = {};

})(jQuery);



/**
 * SGVerticalTabs
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGVerticalTabs = function(options) {

        var settings = $.extend( {}, $.fn.SGVerticalTabs.defaults, options );

        function ajustHeight(){
            /*
            let minHeight = 0;
            this.$container.find('.dce-verticalTabs__contents__item').each(function(){
                if($(this).height() > minHeight){
                    minHeight = $(this).height();
                };
            });
            this.$container.find('.dce-verticalTabs__contents').height(minHeight);
            */
        }



        return this.each(function() {

            function __ajustHeight(){
                let minHeight = 0;
                $this.find('.dce-verticalTabs__contents__item').each(function(){
                    if($(this).height() > minHeight){
                        minHeight = $(this).height();
                    };
                });
                $this.find('.dce-verticalTabs__contents').height(minHeight);
            }

            function __chooseItem(index){

                // on stocke l'element cliqué
                let $clickedElt = $this.find('.dce-verticalTabs__tabs__item').eq(index);

                // on change les onglet de class
                $this.find('.dce-verticalTabs__tabs__item').eq(__currentId).removeClass('dce-verticalTabs__tabs__item--active');
                $clickedElt.addClass('dce-verticalTabs__tabs__item--active');

                // on bouge le curseur qui va bien (correspond à la différence entre sa posY et la posY de son parent)
                let topY = verge.rectangle($clickedElt).top - verge.rectangle($this.find('.dce-verticalTabs__tabs')).top;
                TweenMax.to($this.find('.dce-verticalTabs__cursor'), 0.8, {y: topY, ease: Expo.easeInOut});


                // on masque l'ancien onglet
                TweenMax.to($this.find('.dce-verticalTabs__contents__item').eq(__currentId), 0.8, {autoAlpha: 0});
                $this.find('.dce-verticalTabs__contents__item').eq(__currentId).removeClass('dce-verticalTabs__contents__item--active');
                TweenMax.to($this.find('.dce-verticalTabs__contents__item').eq(index), 0.8, {autoAlpha: 1});
                $this.find('.dce-verticalTabs__contents__item').eq(index).addClass('dce-verticalTabs__contents__item--active');

                __currentId = index;
            }


            var $this = $(this);

            // choix par defaut
            let __currentId = 0;
            __chooseItem(__currentId);

            // click handler
            $this.find('.dce-verticalTabs__tabs__item').on('click', function(){
                __chooseItem($(this).data('uid'));
            });

            // on ajsute la hauteur du bloc
            __ajustHeight();

        });
    }



    $.fn.SGVerticalTabs.defaults = {};

})(jQuery);




/**
 * [description]
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
(function($) {

    $.fn.SGCarouselKeys = function(options) {

        var settings = $.extend( {}, $.fn.SGCarouselKeys.defaults, options );

        console.debug('SGCarouselKeys', settings);


        function __animateKeys(){
            let $key = $(this.$owlItems[this.currentItem]).find('.dce-carouselKeys__slide__key');
            $key.counterUp({
                delay: 10,
                //time: ((settings.autoPlay != undefined) ? parseInt(settings.autoPlay)-1000 : 2000)
                time: 1000
            });
        }
        return this.each(function() {
            // on fait deja un petit carrousel
            $(this).owlCarousel({
                autoPlay: ((settings.autoPlay != "") ? settings.autoPlay : false),
                singleItem:true,
                transitionStyle : "fadeUp",
                afterMove: __animateKeys,
                afterInit: __animateKeys,
            });
        });
    }



    $.fn.SGCarouselKeys.defaults = {};

})(jQuery);
